
//import './Copyright.css';

function SelectInput(props) {
    const start = new Date().getFullYear();
    const setItem = (item) => {
        props.handleChange({ target: { value: item } })
        console.log(item)
    }
    return (<div className="select">
        <div className="selected">
            {(typeof props.selected !== "undefined" && props.selected !== null && props.selected.name) || props.placeholder}
        </div>
        <div className="list">
            {
                props.items.map((item) => { return (<div className="item" onClick={() => { setItem(item) }} key={item.id}>{item.name} </div>) })
            }

        </div>
    </div>);
}

export default SelectInput;
